import { useState } from 'react';
// Reddux
import { useSelector } from 'react-redux';
// Hooks
import { useScrollToTop } from '../../hooks/useScrollToTop';
// Components
import Container from '../Container';
// Utils
import { removeElement } from '../../utils/removeElement';
// Icons
import { IoMdOptions } from 'react-icons/io';
import { TbChevronUp } from 'react-icons/tb';
import { IoMdClose } from 'react-icons/io';
// Styles
import './FiltersNews.css';
// Translate
import { useTranslation } from 'react-i18next';

const FiltersNews = ({ selected, setSelected }) => {
  const { t } = useTranslation();
  const { handleScrollToTop } = useScrollToTop();

  const { base_news } = useSelector((state) => state.news);

  const { languageInstitution } = useSelector((state) => state.institution);

  // Variables para visualización de filtros
  const [isOpenSource, setIsOpenSource] = useState(true);
  const [activeFilter, setActiveFilter] = useState(false);

  const handleSelectSource = (source) => {
    handleScrollToTop(0);
    if (selected.includes(source)) {
      setSelected(selected.filter((value) => value !== source));
    } else {
      setSelected([...selected, source]);
    }
  };

  const handleClearSources = () => {
    handleScrollToTop(0);
    setSelected([]);
  };

  const handleRemoveSource = (source) => {
    handleScrollToTop(0);
    setSelected(removeElement(selected, source));
  };

  const texts = {
    en: {
      sources: 'Sources',
    },
    es: {
      sources: 'Bases de datos',
    },
  };

  const getTextInLanguage = (key) => {
    const language = languageInstitution
      ? 'es'
      : 'en';
    return texts[language]?.[key] || 'Text not found';
  };

  const countNewsBySource = base_news?.reduce((counter, element) => {
    const { source } = element;
    counter[source] = (counter[source] || 0) + 1;
    return counter;
  }, {});

  return (
    <>
      <button className='filtersBarIconNews' onClick={() => setActiveFilter(true)} >
        <b>{t('Filters')}</b>
        <IoMdOptions className='optionsIcon' />
      </button>

      <section
        className={
          activeFilter
            ? 'sectionFilterNews activeFilterNews'
            : 'sectionFilterNews'
        }
      >
        <div
          onClick={() => setActiveFilter(false)}
          className={
            activeFilter
              ? 'filterBarBackgroundNews activeFilterNews'
              : 'filterBarBackgroundNews'
          }
        ></div>
        <div className='filtersBarNews'>
          <Container className='filtersBarMainNews'>
            <div>
              <IoMdOptions className='optionsIcon' />
              <h2>{t('Filters')}</h2>
            </div>
            <button onClick={() => setActiveFilter(false)}>
              <IoMdClose className='optionsIconClose' />
            </button>
          </Container>

          {selected?.length > 0 && (
            <Container className='filtersBarSectionNews'>
              <div className='filtersBarSection__main'>
                <h3>{t('Filters')}</h3>
                <button onClick={handleClearSources}>Remove all filters</button>
              </div>
              <div className='filtersBarSectionFilter__content'>
                {selected?.length > 0 &&
                  selected?.map((source, i) => (
                    <button key={i} onClick={() => handleRemoveSource(source)}>
                      {source} <IoMdClose />
                    </button>
                  ))}
              </div>
            </Container>
          )}

          <Container className='filtersBarSectionNews'>
            <div className='filtersBarSection__main' onClick={() => setIsOpenSource(!isOpenSource)} >
              <h3>{getTextInLanguage('sources')}</h3>

              <button >
                <TbChevronUp className={isOpenSource ? '' : 'iconActive'} />
              </button>
            </div>
            {isOpenSource && (
              <div className='filtersBarSection__content fixed'>
                {Object.entries(countNewsBySource)?.map((source, i) => {
                  return (
                    <button
                      key={i}
                      className={selected.includes(source[0]) ? 'selected' : ''}
                      onClick={() => handleSelectSource(source[0])}
                    >
                      {`${source[0]} (${source[1]})`}
                    </button>
                  );
                })}
              </div>
            )}
          </Container>
        </div>
      </section>
    </>
  );
};

export default FiltersNews;
